import React from "react";
import ErrorPage from "../error/404ErrorPage.component";

export const authRoutes = [
    { path: `${process.env.PUBLIC_URL}/404-error`, Component: <ErrorPage /> },
]